<template>
  <b-row>
    <b-col cols="12" md="4">
      <statistic-card-horizontal
        icon="UsersIcon"
        :statistic="statistic.waiting"
        :statistic-title="$t('application.interviewCard.waitingForInterview')"
        color="warning"
        :class="{ 'cursor-pointer': true, 'btn-outline-primary': groupFilter === 'waiting' }"
        @click="handleSelectStatistic('waiting')"
      />
    </b-col>

    <b-col cols="12" md="4">
      <statistic-card-horizontal
        icon="UserCheckIcon"
        :statistic="statistic.interviewing"
        :statistic-title="$t('application.interviewCard.interviewInProgress')"
        color="info"
        :class="{ 'cursor-pointer': true, 'btn-outline-primary': groupFilter === 'interviewing' }"
        @click="handleSelectStatistic('interviewing')"
      />
    </b-col>

    <b-col cols="12" md="4">
      <statistic-card-horizontal
        icon="BookIcon"
        :statistic="statistic.documents_requested"
        :statistic-title="$t('application.interviewCard.documentsPending')"
        class="cursor-pointer"
        :class="{
          'cursor-pointer': true,
          'btn-outline-primary': groupFilter === 'documents_requested',
        }"
        @click="handleSelectStatistic('documents_requested')"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import StatisticCardHorizontal from '@hw-ui/components/statistics-cards/StatisticCardHorizontal.vue'

export default {
  components: {
    BRow,
    BCol,
    StatisticCardHorizontal,
  },

  props: {
    groupFilter: {
      type: [String, null],
      default: null,
    },
  },

  data() {
    return {
      statistic: {
        waiting: 'Fetching...',
        interviewing: 'Fetching...',
        documents_requested: 'Fetching...',
      },
    }
  },

  created() {
    this.$emit('fetch-statistics', {
      callback: statistic => {
        this.statistic = statistic
      },
    })
  },

  methods: {
    handleSelectStatistic(group) {
      this.$emit('update:groupFilter', this.groupFilter === group ? null : group)
    },
  },
}
</script>

<style lang="scss"></style>
